import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { encryptAES } from "../../Common/Axios/encrypt";
import { dataFromDealPage } from "../../Store/Slices/utilityReducer.js";
import {
  ClientPlatformCode,
  DefaultCardName,
  GetMerchantBgColor,
  ThemeData,
  UserIdAndStatusData,
  trackEvent,
} from "../../Utility/Utility";

const BrandCard = ({
  deal,
  dealCoupons = [],
  index = 0,
  sectionData,
  isMobileView,
  clientCode,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { clientCode: platformClientCode, platformCode } = ClientPlatformCode();
  const { userId, userStatus } = UserIdAndStatusData();
  const defaultCardName = DefaultCardName();
  const themeData = ThemeData();
  const merchantBgColor = GetMerchantBgColor(deal, themeData);

  const offerCount = dealCoupons?.length || 0;
  const offerLabel = offerCount > 1 ? `${offerCount} Offers` : "1 Offer";

  const imagePath = isMobileView ? deal?.mobImage : deal?.webImage;
  const placeholderSrc = `${process.env.REACT_APP_CLIENT_IMAGE_URL}${clientCode}/img/Placeholder.svg`;
  const imageSrc = imagePath
    ? `${process.env.REACT_APP_CLIENT_IMAGE_URL}${imagePath}`
    : placeholderSrc;

  const handleBrandCardClick = () => {
    dispatch(
      dataFromDealPage({
        dealData: deal,
        dealCouponData: dealCoupons,
      })
    );

    trackEvent("select_offer_card", {
      section_title: sectionData?.text,
      image_url: `${process.env.REACT_APP_CLIENT_IMAGE_URL}${deal?.mobImage}`,
      page_type: location?.pathname === "/" ? "home_page" : "",
      brand_name: deal?.name,
      item_position: index + 1,
      client_code: platformClientCode,
      platform_code: platformCode,
      user_id: userId,
      user_status: userStatus,
      card_name: defaultCardName,
    });

    navigate(`/Offers?did=${encryptAES(String(deal?.id))}`);
  };

  return (
    <div className="brand-card" onClick={handleBrandCardClick}>
      <div
        className="brand-card-image-wrap"
        style={merchantBgColor ? { backgroundColor: merchantBgColor } : undefined}
      >
        <img
          className="brand-card-image"
          src={imageSrc}
          alt={deal?.name}
          title={deal?.name}
          onError={(e) => (e.target.src = placeholderSrc)}
        />
        <span className="brand-card-badge">{offerLabel}</span>
      </div>
      <div className="brand-card-name" title={deal?.name}>
        {deal?.name}
      </div>
    </div>
  );
};

export default BrandCard;
